import _ from "lodash"

const nspCountryColor = "#bcbcbc"

export const getCompetitionAltname = function (
  competition,
  altnames,
  pageContext
) {
  altnames = _.map(altnames, "node")
  const altnameObject = _.find(altnames, {
    entityId: competition.mysqlId,
    entityType: "comp",
    season: pageContext.seasonId,
  })
  competition.altName = altnameObject
    ? altnameObject.altValue
    : competition.label
}

export const getTotalAverage = function (compseasonDataset) {
  const attendances = compseasonDataset
    .map(edge => (edge.node.attendance ? edge.node.attendance : null))
    .filter(Boolean) //remove null
  const sum = attendances.reduce((a, b) => a + b, 0)
  const average = sum / attendances.length
  return Math.round(average)
}

export const getHighestAttendance = function (compseasonDataset) {
  if (compseasonDataset.length === 0) {
    return {}
  }
  return compseasonDataset.reduce((prev, current) =>
    prev.node.attendance > current.node.attendance ? prev : current
  )
}

export const getLowestAttendance = function (compseasonDataset) {
  if (compseasonDataset.length === 0) {
    return {}
  }
  return compseasonDataset
    .filter(edge => !!edge.node.attendance)
    .reduce((prev, current) =>
      current.node.attendance !== null &&
      prev.node.attendance !== null &&
      prev.node.attendance < current.node.attendance
        ? prev
        : current
    )
}

const getCountryColor = function (countries, iso3) {
  let country = countries.find(c => c.node.iso3 === iso3)
  if (country) {
    return country.node.color
  }
  return nspCountryColor
}

export const getCompSeasonBubbleChartData = function (
  compseasonDataset,
  countries
) {
  return compseasonDataset.map(edge => ({
    gamedate: edge.node.gamedate,
    team1: edge.node.team1,
    team2: edge.node.team2,
    attendance: edge.node.attendance,
    country: edge.node.country,
    color: getCountryColor(countries, edge.node.country),
  }))
}

export const getCompSeasonBubbleChartCountries = function (
  compseasonDataset,
  countries
) {
  let datasetCountries = _(compseasonDataset).map("node.country").uniq().value()
  let countryNodes = countries.filter(function (country) {
    return datasetCountries.includes(country.node.iso3)
  })

  return countryNodes.map(edge => ({
    name: edge.node.name,
    iso2: edge.node.iso2,
    iso3: edge.node.iso3,
    color: edge.node.color,
  }))
}

export const getAverageByCountry = function (compseasonDataset, countries) {
  let datasetCountries = _(compseasonDataset).map("node.country").uniq().value()
  if (datasetCountries.length === 1 && datasetCountries[0] === "country") {
    return []
  }
  let countryNodes = countries.filter(function (country) {
    return datasetCountries.includes(country.node.iso3)
  })

  return countryNodes.map(edge => ({
    country: {
      name: edge.node.name,
      iso2: edge.node.iso2,
      iso3: edge.node.iso3,
      color: edge.node.color,
    },
    average: getAverage(
      _(compseasonDataset)
        .map("node")
        .filter({
          country: edge.node.iso3,
        })
        .map("attendance")
        .value()
    ),
  }))
}

export const getAverageByMonth = function (compseasonDataset) {
  const rows = _.map(compseasonDataset, "node")
  var startDate = new Date(_.min(_.map(rows, "gamedate")))
  var endDate = new Date(_.max(_.map(rows, "gamedate")))
  var start = startDate.getMonth()
  var end = endDate.getMonth()
  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]
  var seasonMonths =
    start <= end
      ? months.slice(start, end + 1)
      : months.slice(start - months.length).concat(months.slice(0, end + 1))
  var averageByMonth = []
  for (var i = 0; i < seasonMonths.length; i++) {
    averageByMonth.push({
      label: seasonMonths[i],
      chartLabel: seasonMonths[i],
      average: getAverage(
        _(rows).filter(filterCondition).map("attendance").value()
      ),
    })
  }

  return averageByMonth

  function filterCondition(o) {
    var rowDate = new Date(o.gamedate)
    return rowDate.getMonth() === months.indexOf(seasonMonths[i])
  }
}

export const getAverageByStage = function (compseasonDataset) {
  const rows = _.map(compseasonDataset, "node")
  var stages = _(rows).map("stage").uniq().value()
  var averageByStage = []
  for (var i = 0; i < stages.length; i++) {
    averageByStage.push({
      label: getStageLabel(stages[i]),
      chartLabel: stages[i],
      average: getAverage(
        _(rows).filter(filterCondition).map("attendance").value()
      ),
    })
  }
  return averageByStage

  function filterCondition(o) {
    return o.stage === stages[i]
  }

  function getStageLabel(stage) {
    switch (stage) {
      case "RS":
        return "Regular Season"
      case "QF":
        return "Quarterfinals"
      case "QR":
        return "Qualification Round"
      case "SF":
        return "Semifinals"
      case "PR":
        return "Placement Round"
      case "FIN":
        return "Finals"
      case "FR":
        return "PO FIrst Round"
      case "SR":
        return "PO Second Round"
      case "CF":
        return "Conference  Finals"
      case "DS":
        return "Division Semifinals"
      case "DF":
        return "Division Finals"
      case "CQ":
        return "Conference Quarterfinals"
      case "CS":
        return "Conference Semifinals"
      case "R16":
        return "Round 16"
      case "GS":
        return "Group Stage"
      case "BM":
        return "Bronze Match"
      case "PIN":
        return "Play-in"
      default:
        return stage
    }
  }
}

export const getAverageByTeamHome = function (
  compseasonDataset,
  allteams,
  countries
) {
  const rows = _.map(compseasonDataset, "node")
  const compseasonTeams = _.concat(_.map(rows, "team1"), _.map(rows, "team2"))
  const teams = _.map(allteams, "node").filter(function (team) {
    return _.includes(compseasonTeams, team.altName)
  })
  countries = _.map(countries, "node")
  var averageByTeam = []
  for (var i = 0; i < teams.length; i++) {
    averageByTeam.push({
      label: teams[i].altName,
      chartLabel: teams[i].shortName,
      average: getAverage(
        _(rows).filter(filterCondition).map("attendance").value()
      ),
      color: teams[i].country
        ? _.find(countries, {
            iso3: teams[i].country,
          }).color
        : nspCountryColor,
      urlSlug: teams[i].urlSlug,
    })
  }
  return averageByTeam

  function filterCondition(o) {
    return o.team1 === teams[i].altName
  }
}

export const getMapData = function (
  competition,
  locations,
  averageByTeamHome,
  teams,
  compseason,
  title
) {
  teams = _.map(teams, "node")
  locations = _.map(locations, "node")
  compseason = _.map(compseason, "node")
  var mapDataObject = {
    legendTitle: title,
  }
  if (competition.type === "tournament" && locations.length > 0) {
    let compseasonLocations = _(compseason).map("location").uniq().value()
    locations = locations.filter(location =>
      compseasonLocations.includes(location.mysqlId)
    )
    locations.forEach(function (location) {
      location.label = location.mysqlId
      location.average = getAverage(
        _(compseason)
          .filter({ location: location.label })
          .map("attendance")
          .value()
      )
    })
    //.forEach(location => (location.label = location.mysqlId))
    mapDataObject.mapData = locations
  } else {
    mapDataObject.mapData = averageByTeamHome
      .map(function (homeAverageObject) {
        var teamDetailObject = teams.find(team => {
          return team.altName === homeAverageObject.label
        })
        if (teamDetailObject) {
          homeAverageObject.latitude = teamDetailObject.latitude
          homeAverageObject.longitude = teamDetailObject.longitude
          homeAverageObject.country = teamDetailObject.country
          return homeAverageObject
        } else {
          return undefined
        }
      })
      .filter(function (e) {
        //remove empty elements (teams not recognized)
        return e.latitude && e.longitude
      })
      .sort((a, b) => parseInt(b.average) - parseInt(a.average)) //ensure that smaller bubbles are not covered by larger ones
  }

  return mapDataObject
}

export const getAverageByTeamAway = function (
  compseasonDataset,
  allteams,
  countries
) {
  const rows = _.map(compseasonDataset, "node")
  const compseasonTeams = _.concat(_.map(rows, "team1"), _.map(rows, "team2"))
  const teams = _.map(allteams, "node").filter(function (team) {
    return _.includes(compseasonTeams, team.altName)
  })
  countries = _.map(countries, "node")
  var averageByTeam = []
  for (var i = 0; i < teams.length; i++) {
    averageByTeam.push({
      label: teams[i].altName,
      chartLabel: teams[i].shortName,
      average: getAverage(
        _(rows).filter(filterCondition).map("attendance").value()
      ),
      color: teams[i].country
        ? _.find(countries, {
            iso3: teams[i].country,
          }).color
        : nspCountryColor,
      urlSlug: teams[i].urlSlug,
    })
  }
  return averageByTeam

  function filterCondition(o) {
    return o.team2 === teams[i].altName
  }
}

export const getAverageByTeamHomeAway = function (
  compseasonDataset,
  allteams,
  countries,
  competition
) {
  const rows = _.map(compseasonDataset, "node")
  const compseasonTeams = _.concat(_.map(rows, "team1"), _.map(rows, "team2"))
  const teams = _.map(allteams, "node").filter(function (team) {
    return _.includes(compseasonTeams, team.altName)
  })
  countries = _.map(countries, "node")
  var averageByTeam = []
  var i
  if (competition.teams === "countries") {
    for (i = 0; i < teams.length; i++) {
      averageByTeam.push({
        label: teams[i].altName,
        chartLabel: teams[i].altName,
        average: getAverage(
          _(rows).filter(filterCondition).map("attendance").value()
        ),
        color: nspCountryColor,
      })
    }
  } else {
    for (i = 0; i < teams.length; i++) {
      averageByTeam.push({
        label: teams[i].altName,
        chartLabel: teams[i].shortName,
        average: getAverage(
          _(rows).filter(filterCondition).map("attendance").value()
        ),
        color: getTeamColor(teams[i]),
        urlSlug: teams[i].urlSlug,
      })
    }
  }
  return averageByTeam

  function filterCondition(o) {
    return o.team1 === teams[i].altName || o.team2 === teams[i].altName
  }

  function getTeamColor(team) {
    let color
    if (team.country) {
      //a club with country set
      color = (
        _.find(countries, {
          iso3: team.country,
        }) || {}
      ).color
    } else {
      //'team' may be a country
      color = (
        _.find(countries, {
          name: team.altName,
        }) || {}
      ).color
    }
    return color || nspCountryColor
  }
}

export const dateToString = function (date) {
  date = new Date(date)
  return [
    date.getFullYear(),
    (parseInt(date.getMonth()) + 101).toString().substr(1),
    (parseInt(date.getDate()) + 100).toString().substr(1),
  ].join("-")
}

export const getSeasonMapData = function (seasonAverageByComp, competitions) {
  seasonAverageByComp = _.map(seasonAverageByComp, "node")
  competitions = _.map(competitions, "node")
  return _.map(seasonAverageByComp, function (compAverage) {
    let competition = _.find(competitions, { mysqlId: compAverage.compid })
    return {
      id: compAverage.compid,
      short: competition.short,
      label: competition.label,
      type: competition.type,
      logo: competition.logo,
      latitude: competition.latitude,
      longitude: competition.longitude,
      teams: competition.teams,
      average: compAverage.average,
    }
  })
}

export const getUniqTeams = function (allMysqlTeams) {
  return _.uniqBy(allMysqlTeams, "urlSlug")
}

export const getTeamStats = function (
  compseasonDataset,
  altNames,
  competitions
) {
  if (compseasonDataset.length === 0) return []
  competitions = _.map(competitions, "node")
  compseasonDataset = _.map(compseasonDataset, "node")
  const rows = _(compseasonDataset)
    .filter(function (row) {
      return _.includes(altNames, row.team1) || _.includes(altNames, row.team2)
    })
    .value()

  const teamCompetitions = _(rows).map("competition").uniq().value()

  let returnObject = []
  teamCompetitions.forEach(function (compId) {
    const competition = _.find(competitions, { mysqlId: compId })
    const seasonIds = _(rows)
      .filter({ competition: compId })
      .map("season")
      .uniq()
      .value()
    returnObject.push({
      compLabel: competition.label,
      compId: competition.mysqlId,
      seasonAverages: _(
        getTeamCompSeasonAverages(
          compseasonDataset,
          compId,
          seasonIds,
          altNames
        )
      )
        .sortBy("season")
        .value(),
    })
  })
  return returnObject
}

const getTeamCompSeasonAverages = function (
  dataset,
  compId,
  seasonIds,
  altNames
) {
  let returnObject = []
  seasonIds.forEach(function (seasonId) {
    returnObject.push({
      season: seasonId,
      teamAverage: getAverage(
        _(dataset)
          .filter(function (row) {
            return (
              row.competition === compId &&
              row.season === seasonId &&
              _.includes(altNames, row.team1)
            )
          })
          .map("attendance")
          .value()
      ),
      compAverage: getAverage(
        _(dataset)
          .filter(function (row) {
            return row.competition === compId && row.season === seasonId
          })
          .map("attendance")
          .value()
      ),
    })
  })
  returnObject.forEach(function (stat, index) {
    stat.seasonString = seasonParamToString(stat.season)
    if (
      returnObject[index - 1] &&
      returnObject[index - 1].teamAverage !== "-" &&
      stat.teamAverage !== "-"
    ) {
      stat.teamAverageChange =
        Math.round(
          (stat.teamAverage * 100) / returnObject[index - 1].teamAverage
        ) - 100
      if (stat.teamAverageChange < 1 && stat.teamAverageChange > -1) {
        stat.teamAverageChange =
          Math.round(
            ((stat.teamAverage * 100) / returnObject[index - 1].teamAverage -
              100) *
              10
          ) / 10
      }
    }
    stat.percentage =
      typeof stat.teamAverage === "number"
        ? Math.round((stat.teamAverage / stat.compAverage) * 100)
        : undefined
  })
  return returnObject
}

export const getTeamChartStats = function (teamStats) {
  let returnArray = []
  if (!teamStats[0]) return []
  //csak az elso bajnoksag, TODO
  teamStats[0].seasonAverages.forEach(function (seasonAverage) {
    returnArray.push({
      teamAverage: seasonAverage.teamAverage,
      season: seasonAverage.season,
      compAverage: seasonAverage.compAverage,
      seasonString: seasonAverage.seasonString,
      percentage: seasonAverage.percentage,
    })
  })
  return returnArray
}

export const seasonParamToString = function (season, comp) {
  if (typeof season !== "string" || season.length !== 4) return
  if (comp === "wc") {
    return "20" + season.substr(2)
  } else {
    return "20" + season.substr(0, 2) + "/" + season.substr(2)
  }
}

const getAverage = function (valueArray) {
  if (valueArray.length === 0) return "-"
  var sum = 0,
    nrEl = 0
  for (var i = 0; i < valueArray.length; i++) {
    var intValue = parseInt(valueArray[i], 10)
    if (_.isFinite(intValue)) {
      sum += intValue
      nrEl++
    }
  }
  if (nrEl === 0) return "no data"
  return Math.round(sum / nrEl)
}
